import gql from "graphql-tag"
import { useMutation } from "@apollo/react-hooks"

const setShopifyIntegrationMutation = gql`
  mutation setShopifyAppIntegration(
    $shopName: String!
    $siteId: UUID!
    $shopifyStoreFrontToken: String
    $shopifyAppToken: String!
  ) {
    setShopifyAppIntegration(
      shopName: $shopName
      siteId: $siteId
      shopifyAppToken: $shopifyAppToken
      shopifyStoreFrontToken: $shopifyStoreFrontToken
    ) {
      success
      message
    }
  }
`

export function useSetShopifyAppIntegration() {
  const [shopifyMutation] = useMutation(setShopifyIntegrationMutation)

  return {
    setShopifyAppIntegration: siteId => {
      const shopName = localStorage.getItem(`gatsby:shopifyshop`)
      const shopifyAppToken = localStorage.getItem(`gatsby:shopifyapptoken`)
      const shopifyStoreFrontToken = localStorage.getItem(
        `gatsby:shopifyappstorefronttoken`
      )

      return shopifyMutation({
        variables: {
          shopName,
          shopifyAppToken,
          shopifyStoreFrontToken,
          siteId,
        },
      })
    },
    clearShopifyStorageInfo: () => {
      localStorage.setItem(`gatsby:shopifyshop`, undefined)
      localStorage.setItem(`gatsby:shopifyapptoken`, undefined)
      localStorage.setItem(`gatsby:shopifyappstorefronttoken`, undefined)
    },
  }
}
